import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Media from 'sb-media'
import { constants } from 'common/helpers'

import Modal from 'components/modal/Modal/Modal'

import ExceptMobile from './ExceptMobile/ExceptMobile'
import Mobile from './Mobile/Mobile'

import messages from './messages'

// TODO this modal can be implemented via css without Media component
export default class ConfirmModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    title: PropTypes.object.isRequired,
    confirmTitle: PropTypes.object,
    cancelTitle: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
    subText: PropTypes.any,
    children: PropTypes.any,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onClose: PropTypes.func,
    withTextCancel: PropTypes.bool,
  }

  static defaultProps = {
    cancelTitle: messages.back,
  }

  confirm = () => {
    const { onConfirm } = this.props

    if (typeof onConfirm === 'function') {
      onConfirm()
    }
  }

  cancel = () => {
    const { onCancel } = this.props

    if (typeof onCancel === 'function') {
      onCancel()
    }
  }

  render() {
    const { children, name, title, confirmTitle, cancelTitle, subText, onClose, withTextCancel } = this.props

    const cancelTestId = constants.testIds.modal.confirmModal.cancelButton
    const confirmTestId = constants.testIds.modal.confirmModal.confirmButton

    return (
      <Modal
        name={name}
        title={title}
        subText={subText}
        onClose={onClose}
      >
        <Media mobile>
          {
            (matches) => React.createElement(matches ? Mobile : ExceptMobile, {
              confirmTitle,
              cancelTitle,
              onConfirm: this.confirm,
              onCancel: this.cancel,
              cancelTestId,
              confirmTestId,
              withTextCancel,
            }, children)
          }
        </Media>
      </Modal>
    )
  }
}
